exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-64d99636] .ant-modal-header {\n  border-bottom: none;\n}\n.modal-content[data-v-64d99636] .ant-modal-body {\n  padding: 0 24px 10px;\n}\n.modal-content[data-v-64d99636] .ant-upload {\n  height: 149px;\n}\n", ""]);

// exports
